"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ShieldCheck, Mail, MapPin, Scale } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const policySections = [{
  number: "1",
  title: "Amaç ve Kapsam",
  paragraphs: ["Bu Politika, Av. Raci Çetin Yüksekbaş / Yüksekbaş Hukuk ve Danışmanlık tarafından gerçekleştirilen kişisel veri işleme faaliyetlerinde 6698 sayılı Kişisel Verilerin Korunması Kanunu ve ilgili mevzuata uyum konusunda benimsenen temel esasları açıklar.", "Politika; internet sitesi ziyaretçileri, müvekkiller, danışanlar, büro ile iletişim kuran kişiler ve ilgili diğer tüm gerçek kişilere ait kişisel verilerin işlenmesine ilişkin genel çerçeveyi kapsar."],
  items: []
}, {
  number: "2",
  title: "Veri Sorumlusu",
  paragraphs: ["6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca veri sorumlusu Av. Raci Çetin Yüksekbaş'tır (Yüksekbaş Hukuk ve Danışmanlık).", "Veri sorumlusuna ilişkin iletişim bilgileri ve tebligat adresi bu Politikanın sonunda yer almaktadır."],
  items: []
}, {
  number: "3",
  title: "Kişisel Verilerin İşlenmesinde Temel İlkeler",
  paragraphs: ["Kişisel veriler;"],
  items: ["Hukuka ve dürüstlük kurallarına uygun olma,", "Doğru ve gerektiğinde güncel olma,", "Belirli, açık ve meşru amaçlar için işlenme,", "İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü olma,", "İlgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza edilme"],
  closing: "ilkelerine tam bir bağlılıkla işlenir."
}, {
  number: "4",
  title: "İşlenebilecek Kişisel Veri Kategorileri",
  paragraphs: ["Sunulan hizmet, uyuşmazlığın veya iletişimin niteliğine göre;"],
  items: ["Kimlik verileri (ad, soyad, T.C. kimlik numarası vb.),", "İletişim verileri (telefon numarası, e-posta adresi, yerleşim yeri adresi vb.),", "Hukuki işlem ve danışmanlık verileri (dava ve icra takip dosyası bilgileri, tutanaklar, hukuki yazışmalar),", "Müşteri işlem ve finansal veriler (vekaletname bilgileri, fatura ve ödeme kayıtları),", "Fiziki mekan ve işlem güvenliği verileri,", "İnternet sitesi ve sunucu teknik verileri (log kayıtları, IP adresi vb.)"],
  closing: "işlenebilir. Özel nitelikli kişisel veriler, Kanun'un 6. maddesindeki şartlar ve Kurul kararları çerçevesinde, yalnızca gerekli ve ölçülü olduğu hallerde işlenir."
}, {
  number: "5",
  title: "Kişisel Verilerin Toplanma Yöntemleri",
  paragraphs: ["Kişisel veriler; internet sitesinde yer alan iletişim formları, e-posta iletileri, telefon görüşmeleri, fiziki başvurular, adli ve idari mercilerden intikal eden evraklar, sözleşmeler ve vekaletnameler aracılığıyla fiziki ve/veya elektronik ortamlarda toplanmaktadır."],
  items: []
}, {
  number: "6",
  title: "Kişisel Verilerin İşlenme Amaçları",
  paragraphs: ["Kişisel veriler; avukatlık ve hukuki danışmanlık hizmetlerinin yürütülmesi, vekalet ilişkisinin kurulması ve ifası, müvekkil ve danışan iletişiminin sağlanması, yasal yükümlülüklerin yerine getirilmesi, bir hakkın tesisi, kullanılması veya korunması, büro yönetim ve bilgi güvenliği süreçlerinin yürütülmesi amaçlarıyla işlenir.", "Kişisel veriler hiçbir surette ticari reklam veya izinsiz pazarlama faaliyetlerinde kullanılmaz."],
  items: []
}, {
  number: "7",
  title: "Telefon Görüşmelerinin Kaydedilmesi",
  paragraphs: ["Büro ile gerçekleştirilen telefon görüşmelerinde ses kaydı alınmamaktadır.", "Görüşme sırasında iletilen randevu, talep veya hukuki sürece ilişkin notlar yalnızca işin ifası ve takibi amacıyla yazılı kayda alınabilir."],
  items: []
}, {
  number: "8",
  title: "E-posta Yazışmalarının İşlenmesi",
  paragraphs: ["Büroya iletilen e-posta mesajları, iletinin içeriğinde yer alan hukuki talep, belge ve bilgilerin değerlendirilmesi, cevaplandırılması ve arşivlenmesi amacıyla işlenir.", "E-posta iletişimi kapsamında paylaşılan kişisel verilerin korunması ve gizliliğin sağlanması amacıyla gerekli teknik güvenlik tedbirleri uygulanır."],
  items: []
}, {
  number: "9",
  title: "Kişisel Verilerin İşlenmesinin Hukuki Sebepleri",
  paragraphs: ["Kişisel veriler; KVKK'nın 5. maddesinde belirtilen kanunlarda açıkça öngörülme, bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olma, veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olma, bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması ve meşru menfaat hukuki sebeplerine dayalı olarak işlenir.", "Açık rızanın zorunlu olduğu hallerde rıza usulüne uygun olarak temin edilir; kanuni işleme şartlarının bulunduğu durumlarda açık rıza aranmaz."],
  items: []
}, {
  number: "10",
  title: "Kişisel Verilerin Aktarılması",
  paragraphs: ["Kişisel veriler, mevzuatın izin verdiği ve hizmetin gerektirdiği ölçüde;"],
  items: ["Adli ve idari merciler, mahkemeler, icra daireleri, hakem heyetleri ve yetkili kamu kurum ve kuruluşları,", "Uyuşmazlık kapsamında yetkilendirilen uzmanlar, bilirkişiler ve noterler,", "Hizmetin ifası için zorunlu olan bilgi teknolojileri, sunucu ve altyapı sağlayıcıları"],
  closing: "ile KVKK'nın 8. ve 9. maddelerine uygun olarak paylaşılabilir. Sır saklama yükümlülüğü ve kanuni sınırlar dışında üçüncü şahıslara aktarım yapılmaz."
}, {
  number: "11",
  title: "Avukatlık Sırrı ve Gizlilik",
  paragraphs: ["1136 sayılı Avukatlık Kanunu'nun 36. maddesi uyarınca avukatlar, kendilerine tevdi edilen veya gerek avukatlık görevi gerekse Türkiye Barolar Birliği ve barolar organlarındaki görevleri dolayısıyla öğrendikleri hususları açığa vurmaktan kanunen yasaklıdır.", "Büromuz tarafından işlenen tüm kişisel veriler ve müvekkil bilgileri, avukatlık meslek sırrı kapsamında en üst düzey gizlilik ve özenle muhafaza edilir."],
  items: []
}, {
  number: "12",
  title: "Saklama Süreleri ve İmha",
  paragraphs: ["Kişisel veriler, Avukatlık Kanunu ve ilgili mevzuatta öngörülen dava, takip ve zamanaşımı süreleri boyunca saklanır.", "İletişim formu üzerinden gelen ve hukuki hizmet ilişkisine dönüşmeyen taleplere ait veriler, talebin sonuçlanmasından itibaren en fazla bir yıl süreyle muhafaza edilir.", "Saklama süresi sona eren kişisel veriler, Kişisel Verilerin Silinmesi, Yok Edilmesi veya Anonim Hale Getirilmesi Hakkında Yönetmelik hükümlerine uygun olarak imha edilir."],
  items: []
}, {
  number: "13",
  title: "Veri Güvenliği",
  paragraphs: ["Kişisel verilerin hukuka aykırı olarak işlenmesini ve erişilmesini önlemek, muhafazasını sağlamak amacıyla uygun güvenlik düzeyini temin etmeye yönelik gerekli teknik ve idari tedbirler alınmaktadır.", "Fiziki ve elektronik ortamlardaki verilere erişim yetkileri sınırlandırılmış olup, sistemsel güvenlik yazılımları ve periyodik kontroller uygulanmaktadır."],
  items: []
}, {
  number: "14",
  title: "İnternet Sitesi ve Üçüncü Taraf Hizmetler",
  paragraphs: ["İnternet sitemizde yalnızca sitenin temel işlevlerini yerine getirebilmesi için gerekli olan teknik çerezler kullanılmaktadır.", "Kullanıcıların onayına tabi olmayan hiçbir ticari takip, reklam veya hedefleme çerezi kullanılmamaktadır.", "Harita veya üçüncü taraf entegrasyonlarında kullanıcı gizliliği gözetilmekte ve zorunlu olmayan veri aktarımları engellenmektedir."],
  items: []
}, {
  number: "15",
  title: "İlgili Kişinin Hakları",
  paragraphs: ["İlgili kişiler KVKK'nın 11. maddesi uyarınca veri sorumlusuna başvurarak;"],
  items: ["Kişisel verilerinin işlenip işlenmediğini öğrenme,", "Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,", "Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,", "Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,", "Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,", "KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme,", "İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhine bir sonucun ortaya çıkmasına itiraz etme,", "Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme"],
  closing: "haklarına sahiptir."
}, {
  number: "16",
  title: "Politikanın Güncellenmesi",
  paragraphs: ["Bu Politika, mevzuat hükümleri, Kişisel Verileri Koruma Kurulu kararları veya büro süreçlerindeki gereksinimler doğrultusunda güncellenebilir.", "Politikanın güncel sürümü internet sitesinde yayımlandığı tarihte yürürlüğe girer."],
  items: []
}];
export default function PrivacyPolicy() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="privacypolicybody" data-nav="light" className="relative bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mb-12 md:mb-16 pb-8 border-b border-border">
          <div className="flex flex-wrap items-center gap-2 mb-4">
            <Badge variant="outline" className="border-border text-foreground font-mono text-xs uppercase px-2.5 py-1">
KVKK POLİTİKASI            </Badge>
            <span className="text-xs font-mono text-muted-foreground">
              Sürüm 1.0 • 22.08.2026
            </span>
          </div>

          <h1 className="font-default text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-foreground mb-4">
            Kişisel Verilerin Korunması ve İşlenmesi Politikası
          </h1>

          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed max-w-3xl">
            Av. Raci Çetin Yüksekbaş / Yüksekbaş Hukuk ve Danışmanlık bünyesinde yürütülen kişisel veri işleme faaliyetlerine ilişkin 6698 sayılı Kanun kapsamındaki genel kurallar ve ilkeler aşağıda yer almaktadır.
          </p>
        </motion.div>

        <div className="space-y-12">
          {policySections.map((section, idx) => <motion.article key={section.number} data-index={idx} initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-40px"
        }} transition={{
          duration: 0.4,
          delay: Math.min(idx * 0.03, 0.2)
        }} className="group relative">
              <div className="flex items-baseline gap-3 mb-4">
                <span className="font-mono text-sm text-muted-foreground select-none font-medium">
                  {section.number.padStart(2, "0")}.
                </span>
                <h2 className="font-default text-xl sm:text-2xl font-semibold text-foreground tracking-tight">
                  {section.title}
                </h2>
              </div>

              <div className="pl-6 sm:pl-8 space-y-3.5 border-l border-border/40 ml-1.5">
                {section.paragraphs.map((para, pIdx) => <p key={pIdx} data-index={pIdx} className="text-base leading-relaxed text-foreground/90 font-sans text-justify sm:text-left">
                    {para}
                  </p>)}

                {section.items.length > 0 && <ul className="space-y-2 my-3 pl-2">
                    {section.items.map((item, iIdx) => <li key={iIdx} data-index={iIdx} className="flex items-start gap-2.5 text-base text-foreground/90 font-sans">
                        <span className="h-1.5 w-1.5 rounded-full bg-foreground/60 mt-2 shrink-0" />
                        <span>{item}</span>
                      </li>)}
                  </ul>}

                {section.closing && <p className="text-base leading-relaxed text-foreground/90 font-sans pt-1">
                    {section.closing}
                  </p>}
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-16 pt-8 border-t border-border">
          <Card className="bg-card border border-border shadow-sm">
            <CardContent className="p-6 sm:p-8 space-y-6">
              <div className="flex items-center gap-3">
                <Scale className="size-5 text-foreground shrink-0" />
                <h3 className="font-default text-lg sm:text-xl font-semibold text-card-foreground">
                  Veri Sorumlusu İletişim ve Başvuru Bilgileri
                </h3>
              </div>

              <p className="text-sm text-muted-foreground leading-relaxed">
                KVKK kapsamındaki haklarınıza ilişkin başvurularınızı mevzuata uygun yazılı yöntemlerle ya da kayıtlı elektronik posta ile tarafımıza iletebilirsiniz.
              </p>

              <Separator className="bg-border/60" />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
                <div className="flex items-start gap-3">
                  <MapPin className="size-4 text-muted-foreground mt-1 shrink-0" />
                  <div>
                    <strong className="block text-card-foreground font-medium mb-1">
                      Av. Raci Çetin Yüksekbaş
                    </strong>
                    <span className="text-muted-foreground leading-relaxed">
                      Cevizli Mahallesi, Mustafa Kemal Caddesi, Onat Sokak, No:5/8, Kartal / İstanbul
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <Mail className="size-4 text-muted-foreground mt-1 shrink-0" />
                  <div>
                    <strong className="block text-card-foreground font-medium mb-1">
                      E-Posta İletişimi
                    </strong>
                    <a href="mailto:info@yuksekbas.av.tr" className="text-foreground underline underline-offset-4 hover:text-muted-foreground transition-colors">
                      info@yuksekbas.av.tr
                    </a>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs font-mono text-muted-foreground">
            <div className="flex items-center gap-2">
              <ShieldCheck className="size-4 text-foreground/80" />
              <span>Yüksekbaş Hukuk ve Danışmanlık • KVKK Uyum Dokümantasyonu</span>
            </div>
            <span>Son güncelleme: 22 Ağustos 2026</span>
          </div>
        </motion.div>
      </div>
    </section>;
}